import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generatePath } from 'react-router-dom';
import { Response, Pagination } from '@ui/src';
import {
  RiskScoreItem,
  DeliveryChannel,
  DeliveryChannelValidators,
} from '../../../types';
import { individualClientsRiskApi } from '../services';
import ROUTES from '../../../../routes';

export interface IndividualClientsDeliveryChannelsListState {
  values?: DeliveryChannel[];
  pagination?: Pagination;
  selectedList: string[];
  validators?: DeliveryChannelValidators;
}

const initialState: IndividualClientsDeliveryChannelsListState = {
  values: undefined,
  selectedList: [],
};

export const cndividualClientsDeliveryChannelsSlice = createSlice({
  name: 'individualClientsDeliveryChannels',
  initialState,
  reducers: {
    selectList: (state, action: PayloadAction<string[]>) => {
      state.selectedList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualClientsRiskApi.endpoints.getIndividualDeliveryChannels
        .matchFulfilled,
      (state, action: PayloadAction<Response<RiskScoreItem>>) => {
        state.values = action.payload.data.edges
          .map((item) => ({
            id: item.node.id,
            riskScore: item.node.riskScore,
            name: item.node.name,
            scoreAction: item.node.riskScoreRange.action,
            riskCategory: item.node.riskScoreRange.name,
            riskScoreRangeId: item.node.riskScoreRangeId,
            url: generatePath(
              ROUTES.INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS_EDIT,
              {
                channelId: item.node.id,
              },
            ),
          }))
          .sort((a, b) => b.riskScore - a.riskScore);

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      individualClientsRiskApi.endpoints.getDeliveryChannelValidators
        .matchFulfilled,
      (state, action: PayloadAction<{ data: DeliveryChannelValidators }>) => {
        state.validators = action.payload.data;
      },
    );
    builder.addMatcher(
      individualClientsRiskApi.endpoints.updateIndividualDeliveryChannel
        .matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        const { data } = action.payload;

        const nextList = state.values?.map((item) => {
          let result = { ...item };

          if (result.id === data.id) {
            result = {
              id: data.id,
              riskScore: data.riskScore,
              name: data.name,
              scoreAction: data.riskScoreRange.action,
              riskCategory: data.riskScoreRange.name,
              riskScoreRangeId: data.riskScoreRangeId,
              url: generatePath(
                ROUTES.INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS_EDIT,
                {
                  channelId: data.id,
                },
              ),
            };
          }

          return result;
        });

        state.values = nextList;
      },
    );
  },
});

export const { selectList } = cndividualClientsDeliveryChannelsSlice.actions;

export default cndividualClientsDeliveryChannelsSlice.reducer;
